import React, { useContext, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { LanguageCode } from '@tink/config/src/markets';

export type LocaleStateContext = {
  changeLocale: (locale: LanguageCode) => void;
  locale: LanguageCode | undefined;
};

export const LocaleStateContext = React.createContext<LocaleStateContext>({
  changeLocale: () => undefined,
  locale: undefined,
});

export type Messages = Record<string, string>;

export type MessagesInLocales = Partial<Record<LanguageCode, Messages>>;

export type LanguageProviderProps = {
  defaultLocale: LanguageCode;
  messages: MessagesInLocales;
};

export const LanguageProvider: React.FC<LanguageProviderProps> = ({
  defaultLocale,
  messages,
  children,
}) => {
  const [locale, changeLocale] = useState(defaultLocale);
  const msgs = messages[locale];

  return (
    <LocaleStateContext.Provider
      value={{
        changeLocale,
        locale,
      }}
    >
      <IntlProvider locale={locale} key={locale} messages={msgs}>
        {children}
      </IntlProvider>
    </LocaleStateContext.Provider>
  );
};

export const useLanguage = () => useContext(LocaleStateContext);
